// UserSelector.jsx
import React, { useState } from "react";
import CreateUser from "./createUser";
import ExistingUser from "./ExistingUser";

const UserSelector = () => {
  const [selectedOption, setSelectedOption] = useState("new");

  const radioItemStyle = {
    display: "flex",
    alignItems: "center",
    gap: "6px",
    cursor: "pointer",
    fontSize: "13px",
    margin: 0,
  };

  return (
    <div style={{ padding: "0px" }}>
      <div style={{ display: "flex", alignItems: "center", gap: "16px" }}>
        <label style={radioItemStyle}>
          <input
            type="radio"
            name="userType"
            value="new"
            checked={selectedOption === "new"}
            onChange={(e) => setSelectedOption(e.target.value)}
            style={{ margin: 0, cursor: "pointer" }}
          />
          New
        </label>
        <label style={radioItemStyle}>
          <input
            type="radio"
            name="userType"
            value="existing"
            checked={selectedOption === "existing"}
            onChange={(e) => setSelectedOption(e.target.value)}
            style={{ margin: 0, cursor: "pointer" }}
          />
          Existing
        </label>
      </div>

      <div style={{ marginTop: "4px" }}>
        {selectedOption === "new" ? <CreateUser /> : <ExistingUser />}
      </div>
    </div>
  );
};

export default UserSelector;
